<section>
    <div class="container py-3">
      <header class="text-center mb-5 pb-5 mt-5">
        <div class="row">
          <div class="col-lg-7 mx-auto mt-5">
            <h2 class="h1 w-100 text-center fw-bold">Pricing</h2>
            <div class="custom-separator my-4 mx-auto bg-primary mb-5"></div>                        
            <a (click)="openFeedback()" class="btn btn-primary py-2 px-4 rounded-3 shadow">Share Feedback.</a>
          </div>
        </div>
      </header>
  
      <div class="row text-center align-items-end">
        <!-- Package-->
        <div class="col-lg-{{ 12 / ((packages$ | async)?.length ?? 1) }} mb-5 mb-lg-0" *ngFor="let package of (packages$ | async) ?? [];">
          <div class="p-5 rounded-3 shadow border border-primary price-category" [ngClass]="{'active': package.purchased}">
            <h1 class="h6 text-uppercase fw-bold mb-4">{{package.fullName}}</h1>
            <h2 class="h1 fw-bold">{{package.price}}<span class="text-small fw-normal ml-2">/ {{package?.cycle}}</span></h2>
  
            <div class="custom-separator my-4 mx-auto bg-primary"></div>
            <ul class="list-unstyled my-5 text-small text-center">
                <ng-container *ngFor="let item of items;">
                  <li class="mb-3" *ngIf="item.enable">
                      <i class="fa fa-check mr-2 text-primary" ngbTooltip="{{item.description}}">
                          <img *ngIf="item.tier.includes(package.name.toLowerCase())" src="../../../../assets/images/icons/checkbox.svg" class="price-item" alt="{{item.description}}"/>
                          <img *ngIf="!item.tier.includes(package.name.toLowerCase())" src="../../../../assets/images/icons/prohibition.svg"/>
                      </i>
                      {{item.title}}
                  </li>
                </ng-container>
            </ul>
            <button 
              (click)="purchase(package)" 
              [disabled]="package.purchased || (package.name == 'Free' && !package.purchased)"
              class="btn btn-block p-2 shadow w-100" 
              [ngClass]="{'btn-secondary': package.purchased, 'btn-primary': !package.purchased}">
                {{package.purchased? 'Active': package?.action || 'Buy Now'}}</button>
          </div>
        </div>
        <div class="text-center m-auto pt-3">
          <p class="text-secondary"><small>All packages are priced in USD currency</small></p>
        </div>
        <div class="container">
            <div class="col-lg-7 mx-auto mt-5 pt-5">
              <p>Have additional request, contact us to learn more.<br> </p>
              <a href="{{contact_url}}" target="_blank" class="btn btn-primary px-4 py-2 shadow rounded-3 mt-2">Contact Us</a>
            </div>  
        </div>
      </div>
    </div>
  </section>
  